/**
 * Virtual Pageview Tracking — hooks into Swup to track client-side navigations.
 */

import { pushPageView } from './datalayer.js';

/**
 * Initialise virtual pageview tracking on Swup navigations.
 *
 * Hooks into the page:view event (fires after content swap AND head update,
 * so document.title reflects the new page).
 *
 * The initial server-rendered pageview is handled by GTM's built-in
 * pageview trigger — this module only tracks Swup navigations.
 *
 * @param {import('swup').default} swup — Swup router instance
 */
export function initPageviewTracking(swup) {
    swup.hooks.on('page:view', (visit) => {
        pushPageView(visit.to.url, document.title);

        // Re-fire signal for GTM triggers that depend on new page content
        // (e.g., scroll tracking, element visibility).
        // Requires a Custom Event trigger in GTM named 'swup:page:view'.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'swup:page:view' });
    });
}
